<template>
	<div>
		<titles titlename="1X任务考核报名" titlecontent="1X任务考核报名" :mbx="paths"></titles>

		<div class="assessmenttaskcontent">
			<div class="assessmenttaskitem" v-for="item in list" :key="item.JX_GUID">
				<div class="assessmenttaskitemimgbox"><img class="assessmenttaskitemimg" src="@/assets/assessmenttaskdefault.svg" alt="" /></div>
				<div class="asscontent">
					<p class="assessmenttaskitemtitle">{{ item.ExamName }}</p>
					<div class="asscontentbomtm">
						<div class="usercontent">
							<img src="@/assets/userion.svg" alt="" />
							<p>
								报名人数 -
								<span style="color: #FF6B00;">{{ item.Enrollment ?? 0 }}</span>
							</p>
						</div>
						<div class="usercontent" style="margin-left: 3px;">
							<img src="@/assets/dateicon.svg" alt="" />
							<div class="usercontentitle">
								<p>报名截止时间:</p>
								<p>{{ item.Deadlinedate ?? '' }}</p>
							</div>
						</div>
						<div class="usercontent">
							<img src="@/assets/dateicon.svg" alt="" />
							<div class="usercontentitle">
								<p>考试时间:</p>
								<p>{{ item.Examdate ?? '' }}</p>
							</div>
						</div>
						<div class="usercontent">
							<!-- <img src="@/assets/dateicon.svg" alt="" /> -->
							<div class="usercontentitle">
								<p>试卷名称:</p>
								<p>{{ item.SPA_PaperCode }}</p>
							</div>
						</div>
					</div>
				</div>

				<p v-if="item.RegistrationStatus == 0" class="assessmenttaskitembtntext" @click="goenters(item)">立即报名</p>

				<p v-if="item.RegistrationStatus == 1" style="background-color: #bdbdbd;" class="assessmenttaskitembtntext" @click="goenters(item)">已报名</p>
			</div>
		</div>

		<div class="paginationbox" v-if="allnums > list.length">
			<el-pagination
				background
				layout="prev, pager, next"
				@current-change="handleCurrentChange"
				:current-page="pageIndex"
				:page-size="pageSize"
				:total="allnums"
			></el-pagination>
		</div>

		<div style="width: 100%;background-color: #fff;" v-if="list.length == 0"><el-empty description="暂无1x考核任务"></el-empty></div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { GetJxPaperList, Application } from '@/request/api/homesview/yunhomes/yunhom.js';
import AppOptions from '@/config/AppOptions.vue';
export default {
	data() {
		return {
			// 标题组件
			paths: [
				{
					path: '/assessmenttask/Assessmenttaskuserenter',
					name: '1X任务考核报名'
				}
			],
			list: [],
			pageIndex: 1,
			pageSize: 10,
			allnums: 0
		};
	},
	mounted() {
		this.init();
	},
	components: {
		titles
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		init() {
			let datas = {
				where: '',
				pageIndex: this.pageIndex,
				pageSize: this.pageSize
			};
			GetJxPaperList(datas).then(res => {
				// console.log(res,'获取list')
				this.list = res.data.data.list;
				this.allnums = res.data.data.totalCount;
			});
		},
		goenters(ite) {
			// console.log('我要报名', ite);
			let objs = {
				JX_GUID: ite.JX_GUID,
				ui_guid: localStorage.getItem('uiguid')
			};
			Application(objs).then(res => {
				// console.log(res, '报名');
				if (res.data.code == 1) {
					this.$message.success('报名成功');
				}
				this.init();
			});
		},
		handleCurrentChange(val) {
			// console.log(val, '分页1111');
			this.pageIndex = val;
			this.init();
		}
	}
};
</script>

<style scoped lang="less">
.paginationbox {
	width: 100%;
	background-color: #fff;
	padding: 20px 0;
	border-radius: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 20px 0;
	box-sizing: 0 0 16px 0 rgba(0, 0, 0, 0.12);
}

:deep .el-drawer__header {
	font-size: 20px;
	font-weight: 500;
	color: #000 !important;
}

.addstrascenter {
	.ridioslist {
		border: 1px solid #ccc;
		margin: 10px 0;
		position: relative;

		.qustridios {
			background-color: #f2f2f2;
			font-size: 16px;
			padding-left: 10px;
		}
	}

	.qustiopn {
		display: flex;
		align-items: center;
		letter-spacing: 1px;
		margin: 10px;

		p {
			margin: 0 5px;
		}

		.chioce:nth-of-type(2) {
			text-decoration: underline;
			color: rgb(0, 0, 255);
			cursor: pointer;
		}

		div {
			margin-right: 5px;
		}
	}
}

.assessmenttaskcontent {
	display: flex;
	align-items: center;
	flex-direction: column;
	flex-wrap: wrap;
	margin-top: 40px;
	gap: 2%;

	.assessmenttaskitem {
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: space-between;
		// column-gap: 10px;
		margin-bottom: 20px;
		overflow: hidden;
		background-color: #fff;
		border-radius: 10px;
		padding: 20px;
		box-sizing: border-box;
		box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.4);

		.asscontent {
			display: flex;
			// align-items: center;
			justify-content: space-between;
			flex-direction: column;
			height: 120px;

			.asscontentbomtm {
				display: flex;
			}
		}

		.assessmenttaskitembtntext {
			padding: 10px 20px;
			box-shadow: 0px 0px 10px 0px #ccc;
			font-size: 14px;
			border-radius: 4px;
			text-align: center;
			cursor: pointer;
			position: relative;
			background-color: #03c63a;
			margin-left: auto;
			margin-top: 40px;
			color: #fff;
			&::after {
				content: '';
				position: absolute;
				opacity: 1;
				width: 0%;
				height: 2px;
				bottom: 0;
				left: 0;
				background-color: #bdbdbd;
				transition: all 1s;
			}
		}

		.assessmenttaskitembtntext:hover {
			box-shadow: 0px 0px 10px 3px #ccc;
		}

		.assessmenttaskitemimg {
			width: 100%;
			height: 200px;
			transition: all 1s;
		}

		.assessmenttaskitemimgbox {
			width: 20%;
			height: 150px;
			overflow: hidden;
			border-radius: 10px;
			box-sizing: border-box;
		}

		.assessmenttaskitemimg:hover {
			transform: scale(1.2);
		}

		.usercontent {
			margin-left: 10px;
			padding: 10px 10px;
			display: flex;
			align-items: center;

			img {
				margin-right: 10px;
			}
			.usercontentitle {
				font-size: 14px;
				display: flex;
				align-items: center;

				// p:first-child{
				// 	margin-left: 3px;
				// }
			}
			p {
				font-size: 14px;
			}
		}

		.assessmenttaskitemtitle {
			font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
			font-weight: 700;
			font-style: normal;
			font-size: 22px;
			color: #000;
			margin: 20px 0 0 20px;
		}
	}
}

.assessmenttasktitle {
	height: 60px;
	display: flex;
	align-items: center;
	width: 100%;
	border-radius: 5px;
	// border: 1px solid;
	box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.4);
	background-color: #fff;
	justify-content: space-between;
	padding: 0 10px;
}
</style>
